import React, { useMemo } from 'react';
import { Link, Typography } from '@mui/material';
import { Trans } from 'i18n';
import { routes } from 'utils/routing';
import Footer from './Footer';

const UserFooter: React.FC<React.PropsWithChildren<unknown>> = () => {
  const center = useMemo(
    () => (
      <Typography variant="caption">
        <Trans i18nKey="footer.agreement" ns="common" values={{ year: new Date().getFullYear() }}>
          <Link href={routes.termsOfUse().link} target="_blank" />
          <Link href={routes.privacyPolicy().link} target="_blank" />
        </Trans>
      </Typography>
    ),
    [],
  );
  return <Footer center={center} />;
};

export default UserFooter;
